import { render, staticRenderFns } from "./cardboard-mode-instructions.component.vue?vue&type=template&id=1479fd52&"
import script from "./cardboard-mode-instructions.component.vue?vue&type=script&lang=js&"
export * from "./cardboard-mode-instructions.component.vue?vue&type=script&lang=js&"
import style0 from "./cardboard-mode-instructions.component.vue?vue&type=style&index=0&id=1479fd52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports